export const DEFAULT_PAGE_BANNER_COLOR =
  'linear-gradient(224deg,  #8117a7 0%, #1d6ab9 49.48%, #82e580 100%)';
